import Funds from './Funds';

export default Funds;
